/**
 * Types para el modulop de seguridad
 */

export const securityTypes = {
  setDataTruck: "[security] setDataTruck",
  setDataVetaPerson: "[security] setDataVetaPerson",
  setDataVetaDriver: "[security] setDataVetaDriver"
};
